module.exports = "/images/einstein.jpg?60f8d6c61e99813c8c711e5f640c142f";